import axios from '@/http.js';

export default {
    getStatisticData(params) {
        const url = `/api/visit/overview`;
        return axios.get(url, {params});
    },
    getBannerStatisticData(params) {
        const url = `/api/visit/overviewBanner`;
        return axios.get(url, {params});
    },
    getMultiStatisticData(params) {
        const url = `/api/visit/overviewMulti`;
        return axios.get(url, {params});
    },
    getPPTStatisticData(params) {
        const url = `/api/visit/overviewPPT`;
        return axios.get(url, {params});
    },
    getAvgTime(params) {
        const url = `/api/visit/userAvgTime`;
        return axios.get(url, {params});
    },
    getAvgProjectTime(params) {
        const url = `/api/visit/projectTime`;
        return axios.get(url, {params});
    },
    getRandomProcess(params) {
        const url = `/api/visit/randProcess`;
        return axios.get(url, {params});
    },
    getTableData(params) {
        const url = `/api/visit/actionStats`;
        return axios.get(url, {params});
    },
    getCutoutStats(params) {
        const url = '/api/visit/cutoutStats';
        return axios.get(url, {params});
    },
    getWorkStat(params) {
        const url = '/api/visit/workStat';
        return axios.get(url, {params});
    },
    getCustomCategory(params) {
        const url = '/api/visit/project/custom';
        return axios.get(url, {params});
    },
    setCustomCategory(params) {
        const url = '/api/visit/project/set';
        return axios.post(url, params);
    },
    exportWorkStat(params) {
        const url = '/api/visit/exportWorkStat';
        return axios.get(url, {
            params,
            responseType: 'blob'
        });
    },
    getTemplateGroupView(tplGroupId = null, reqTime = '', startTimeFrom = '', startTimeTo = '') {
        var params = new URLSearchParams({tplGroupId, reqTime, startTimeFrom, startTimeTo});
        let url = `/api/visit/templateGroupDetail?${params}`;
        return axios.get(url);
    },
    getTemplateModuleView(templateId, reqTime = '', startTimeFrom = '', startTimeTo = '') {
        var params = new URLSearchParams({templateId, reqTime, startTimeFrom, startTimeTo});
        let url = `/api/visit/materialPsdGroupDetail?${params}`;
        return axios.get(url);
    }
}